import instance from '../_http';

export default {
    /**
     * 查询
     * @param {*} query
     * @returns
     */
    query: (query,page) => {
        return instance.get('/api/travel/payRecords',{params:{...query,page:page.page,size:page.size,sort:page.sort}});
    }
}
